<template lang="pug">
	svg(height='16', viewBox='0 0 16 16', width='16', xmlns='http://www.w3.org/2000/svg')
	  path(d='m668 20-5-5 3-3 5 5 5-5 3 3-5 5 5 5-3 3-5-5-5 5-3-3z', fill='#f05b33', fill-rule='evenodd', transform='translate(-663 -12)' v-if="color == 'red'")
	  path(d='m668 20-5-5 3-3 5 5 5-5 3 3-5 5 5 5-3 3-5-5-5 5-3-3z', fill='#042a4f', fill-rule='evenodd', transform='translate(-663 -12)' v-if="color == 'dark-blue'")
</template>

<script>
export default {
	props:{
		color:{
			default: "red"
		}
	}
}
</script>
